import styled from 'styled-components'

import TextInput from '@/components/DEPRECATED_UI/TextInput'
import { ItemHeader, InputGroup } from '@/components/Style/Common'
import DateStringInput from '@/components/TextInput'
import type { StudentIncome } from '@/types/AddIncome'

import AddressInput from './AddressInput'
import type { PropertyDispatch } from './Behaviour/PropertyDispatch'
import { Property } from './Behaviour/PropertyDispatch'
import IncomePropertiesInput from './IncomePropertiesInput'

const DateField = styled.div`
  display: flex;
  gap: 10px;
  padding: 10px 5px;
`

interface Props {
  income: StudentIncome
  propertyDispatch: PropertyDispatch
}

const StudentInput: React.FC<Props> = ({ income, propertyDispatch }) => {
  return (
    <div>
      <div>
        <ItemHeader>Income Start & End Date</ItemHeader>
        <InputGroup>
          <DateField>
            <DateStringInput
              name="startDate"
              type="date"
              placeholder="dd/mm/yyyy"
              value={income.startDate}
              onChange={value => propertyDispatch.set(Property.StartDate, value)}
            />
            <DateStringInput
              name="endDate"
              type="date"
              placeholder="dd/mm/yyyy"
              value={income.endDate}
              onChange={value => propertyDispatch.set(Property.EndDate, value)}
            />
          </DateField>
        </InputGroup>
      </div>
      <IncomePropertiesInput
        incomeProperties={income.incomeProperties}
        propertyDispatch={propertyDispatch}
        amountProperty={Property.IncomeAmount}
        frequencyProperty={Property.IncomeFrequency}
        hourlyProperty={Property.IncomeHoursPerWeek}
      />
      <div>
        <ItemHeader>Student ID Number</ItemHeader>
        <TextInput
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            propertyDispatch.set(Property.StudentIDNumber, e.target.value)
          }}
          value={income.idNumber}
          label="Student ID Number"
        />
        <ItemHeader>Institution Name</ItemHeader>
        <TextInput
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            propertyDispatch.set(Property.Institution, e.target.value)
          }}
          value={income.institution}
          label="Institution"
        />
        <ItemHeader>Institution Address</ItemHeader>
        <AddressInput address={income.address} propertyDispatch={propertyDispatch} />
      </div>
    </div>
  )
}

export default StudentInput
